export const getSrcset = (imageUrl: string, srcSetValues: number[]): string => {
    return srcSetValues
        .map(
            (value) =>
                `${imageUrl.replace('q_auto', `q_auto,w_${value}`)} ${value}w`
        )
        .toString();
};
